export const terminalCountryCodes = ['SE', 'NL', 'BE', 'FI', 'DK', 'DE', 'NO'] as const

export type TerminalCountryCode = typeof terminalCountryCodes[number]

export const isTerminalCountryCode = (value: unknown): value is TerminalCountryCode =>
  terminalCountryCodes.some((countryCode) => value === countryCode)
